<template>
    <div class="auth flex flex-wrap min-h-screen">
        <alert
                v-model="notify.show"
                :errorType="notify.type"
                :message="notify.message"
        />
        <router-link to="/">
            <img
                    class="inline h-24 p-4 fixed"
                    :src="require('../../../assets/edc-logo-dark.png')"
                    alt=""
            />
        </router-link>
        <div
                style="background: linear-gradient(89.81deg, #111111 0.05%, rgba(46, 58, 110, 0.55) 41.25%), url('https://res.cloudinary.com/dldd8ucby/image/upload/v1590173622/WhatsApp_Image_2020-05-22_at_7.01.56_PM.jpg') no-repeat center center ; background-size: cover;"
                class="w-full md:w-1/2 md:flex hidden items-center justify-center text-center text-black p-6"
        >
            <!-- <div class="mx-4 md:mx-16">
              <span class="welcome-back block">Welcome Back</span>
              <span class="welcome-mini block">Let's get you in the game</span>
            </div> -->
        </div>
        <div
                class="w-full md:w-1/2 text-white  flex items-center justify-center text-center"
        >
            <div class="form w-full md:w-4/5 mx-4 md:mx-auto">
                <p class="purple-bg mx-auto uppercase py-3">Password Reset</p>
                <p class="mini p-3  "> Kindly Enter Your Account Email </p>
                <p><small><i>(Same Address You Have Been Receiving Onboarding Emails From)</i></small></p>
                <div class="mx-4 md:mx-12">
                    <div class="my-6">
                        <input
                                v-model="data.email"
                                @input="errors = {}"
                                class="shadow appearance-none border rounded w-full py-4 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                id="username"
                                type="email"
                                placeholder="Email"
                        />
                        <label class="mt-3 mb-3 ml-3" style="color: red" v-if="errors">{{errors.email}}</label>

                    </div>
                    <p>
                        <small>After Clicking Reset a Reset PIN Will Be Sent To The Email You Type Above</small>
                    </p>
                    <button
                      :disabled="this.loading"
                            @click.prevent="submit"
                            class="purple-bg text-white w-full py-2 px-4 mt-4 mb-2 rounded uppercase"
                    >
                        {{buttonText}}
                    </button>
                </div>
                <div class="flex flex-wrap justify-center mb-4">
                    <p class=" mt-4 forgot-password">
                        <router-link to="/tenant/login"
                        >Remembered Password ? Login here </router-link
                        >
                    </p>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    export default {
        data() {
            return {
                data: {},
                loading: false,
                notify: {
                    type: null,
                    show: false,
                    message: "",
                },
                buttonText: 'RESET',
                errors:[]
            };
        },
        components: {
            Alert: () => import("@/components/admin/alert"),
        },
        mounted() {},
        computed: {
            ...mapGetters(["getUser"]),
        },

        methods: {
            ...mapActions(["forgotPassword"]),
            async submit() {
                if (!this.data.email) {
                    this.handleNotify({
                        type: "error",
                        message: "You need to enter your Email",
                    });
                    return;
                }
                this.loading = true;
                this.buttonText = 'Loading...'
                let res = await this.forgotPassword(this.data);
                if (res === true) {
                    this.loading = false;
                    this.handleNotify({
                        type: "success",
                        message: "Password Reset Email Request Successfully Sent"
                    });
                    this.buttonText = 'Loading...'
                    await this.$router.push({path: `reset-password?email=${this.data.email}`})


                } else {
                    this.loading = false;
                    this.buttonText = 'RESET'
                    this.handleNotify({
                        type: "error",
                        message: res.data.errors
                            ? res.data.errors[0].title
                            : "An error occured",
                    });
                    this.errors = res.data.errors[0].source
                    this.errors.email = 'Account Does Not Exist'
                    // this.$toasted.error(res.data.message).goAway(2500);
                }
            },
            handleNotify(payload) {
                this.notify.show = true;
                this.notify.type = payload.type;
                this.notify.message = payload.message;
            },
        },
    };
</script>

<style scoped>
    .auth {
        background: #102767;
    }

    .form {
        background: #2e3a6e;
    }

    .purple-bg {
        background: #5e6da8;
        color: white;
    }

    .main {
        font-size: 24px;
        line-height: 48px;
    }

    .mini {
        font-size: 14px;
        line-height: 22px;
        margin: 5px auto;
    }
</style>
